module.exports = __webpack_public_path__ + "assets/img/ddbes_pan.f9381624.png";